import { render, staticRenderFns } from "./index.vue?vue&type=template&id=050fe1ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=050fe1ca&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=050fe1ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050fe1ca",
  null
  
)

export default component.exports